import { useQuery } from '@apollo/client/react';
import { Box } from '@chakra-ui/react';
import { EventCalendar } from '@src/components/sco/Events/EventCalendar';
import { EventProfile } from '@src/components/sco/Events/EventProfile';
import { QueryContainer } from '@src/components/sco/QueryContainer';
import { GroupEventCollection } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React from 'react';
type OfficeHoursStepProps = {
  search?: {
    hostFirstName?: string;
    hostLastName?: string;
    title?: string;
  };
};
export const OfficeHoursStep = (props: OfficeHoursStepProps) => {
  const query = useQuery(gql`
    query($title: String) {
      groupEvents(
        isFuture: true
        order: [["startsAt", "asc"]]
        pageSize: 1
        search: $title
        typeKey: "office-hours"
      ) {
        id
        items {
          id
          ${EventProfile.fragments.GroupEvent()}
        }
      }
    }
  `, {
    variables: {
      title: props.search?.title
    }
  });
  return <Box bgColor={'blackAlpha.500'} borderRadius={'1em'} marginBottom={'1em'} padding={'1em'}>
      <QueryContainer query={query} renderData={(data: {
      groupEvents: GroupEventCollection;
    }) => {
      if (data.groupEvents.items[0]) {
        return <EventProfile event={data.groupEvents.items[0]} hideComments={true} />;
      } else {
        return <EventCalendar />;
      }
    }} />
    </Box>;
};